import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {IonicApp, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';

import {MyApp} from './app.component';
import {KontaktePage} from "../pages/kontakte/kontakte";
import {KontakteKundenPage} from "../pages/kontakte-kunden/kontakte-kunden";
import {KontakteDetailsPage} from "../pages/kontakte-details/kontakte-details";
import {SharePruefungPopover} from "../pages/pruefung/pruefung";
import {PopoverPage} from "../pages/pruefung-protokolle/pruefung-protokolle";
import {NgPipesModule} from "ngx-pipes";
import {ModalNavPage} from "../pages/modal-nav/modal-nav";
import {DataProvider} from "../providers/dataprovider/dataprovider";
import {VorlageneditorPage} from "../pages/vorlageneditor/vorlageneditor";
import {ConflictManagementPage} from "../pages/conflict-management/conflict-management";
import {ExistsAuditCustomerPage} from "../pages/exists-audit-customer/exists-audit-customer";
import {ExistsAuditProtocolPage} from "../pages/exists-audit-protocol/exists-audit-protocol";
import {Camera} from "@ionic-native/camera";
import {ImagePicker} from "@ionic-native/image-picker";
import {SettingActiveContractorPage} from "../pages/setting-active-contractor/setting-active-contractor";
import {SettingAdvancedPage} from "../pages/setting-advanced/setting-advanced";
import {SettingCertificatePage} from "../pages/setting-certificate/setting-certificate";
import {SettingRemarksPage} from "../pages/setting-remarks/setting-remarks";
import {SettingNotesPage} from "../pages/setting-notes/setting-notes";
import {Contacts} from "@ionic-native/contacts";
import {AnmerkungstextvorlagenPage} from "../pages/anmerkungstextvorlagen/anmerkungstextvorlagen";
import {HasPipe} from "../pipes/has-pipe";
import {HasNotPipe} from "../pipes/has-not-pipe";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {LoadingServiceProvider} from '../providers/loading-service/loading-service';
import {GlobalProvider} from '../providers/global/global';
import {EmailComposer} from "@ionic-native/email-composer";
import {File} from "@ionic-native/file";
import {DocumentViewer} from "@ionic-native/document-viewer";
import {LoginPage} from "../pages/login/login";
import {DirectivesModule} from "../directives/directives.module";
import {RegisterPage} from "../pages/register/register";
import {AngularFilePickerModule} from 'angular-file-picker';
import {CookieService} from "ngx-cookie-service";
import {SettingDatabaseImportPage} from "../pages/setting-database-import/setting-database-import";
import {ImportProvider} from '../providers/import/import';
import {Network} from "@ionic-native/network";
import {DebounceChange} from "../directives/debounce-change";
import {CalendarProvider} from '../providers/calendar/calendar';
import {Calendar} from "@ionic-native/calendar";
import {PopoverAddContactComponent} from "../components/popover-add-contact/popover-add-contact";
import {DeleteFotoPopoverComponent} from "../components/delete-foto-popover/delete-foto-popover";
import {AddFotoPopoverComponent} from "../components/add-foto-popover/add-foto-popover";
import {BemerkungstextvorlagenComponent} from "../components/bemerkungstextvorlagen/bemerkungstextvorlagen";
import {PruefpunktAddInfoComponent} from "../components/pruefpunkt-add-info/pruefpunkt-add-info";
import {SelectKundeComponent} from "../components/select-kunde/select-kunde";
import {SettingTeamInvitationPage} from "../pages/setting-team-invitation/setting-team-invitation";
import {VorlageneditorInspectionpointDetailsPage} from "../pages/vorlageneditor-inspectionpoint-details/vorlageneditor-inspectionpoint-details";
import {
  PopoverColorChooser,
  VorlageneditorInspectionpointDetailsNewReviewPage
} from "../pages/vorlageneditor-inspectionpoint-details-new-review/vorlageneditor-inspectionpoint-details-new-review";
import {ColorPicker} from "../components/color-picker/color-picker";
import {VorlageneditorMasterdataDetailsPage} from "../pages/vorlageneditor-masterdata-details/vorlageneditor-masterdata-details";
import {SettingPersonalDataPage} from "../pages/setting-personal-data/setting-personal-data";
import {CommentListComponent} from "../components/comment-list/comment-list";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {BackgroundMode} from "@ionic-native/background-mode";
import {ForgotPasswordPage} from "../pages/forgot-password/forgot-password";
import {FileTransfer} from "@ionic-native/file-transfer";
import {HomeModule} from "../pages/home/home.module";
import {PruefungModule} from "../pages/pruefung/pruefung.module";
import {HelpModule} from "../components/help/help.module";
import {SQLite} from "@ionic-native/sqlite";
import {SettingModule} from "../pages/setting/setting.module";
import {FileOpener} from "@ionic-native/file-opener";
import {CleverreportStoreModule} from "../store/cleverreport.store.module";
import {SecureStorage} from "@ionic-native/secure-storage";
import {Device} from "@ionic-native/device";
import {LoginProvider} from "../providers/login/login.provider";
import {HttpModule} from "@angular/http";
import {CrHttpInterceptor} from "../providers/interceptors/crHttpInterceptor";
import {StoreDevtoolsModule} from "@ngrx/store-devtools";
import {AnmerkungstextvorlagenComponent} from "../components/anmerkungstextvorlagen/anmerkungstextvorlagen";

@NgModule({
  declarations: [
    MyApp,
    KontaktePage,
    KontakteKundenPage,
    KontakteDetailsPage,
    ModalNavPage,
    VorlageneditorPage,
    PopoverPage,
    ConflictManagementPage,
    ExistsAuditCustomerPage,
    ExistsAuditProtocolPage,
    SettingActiveContractorPage,
    SettingAdvancedPage,
    SettingCertificatePage,
    SettingRemarksPage,
    SettingNotesPage,
    AnmerkungstextvorlagenPage,
    HasPipe,
    HasNotPipe,
    LoginPage,
    RegisterPage,
    SettingDatabaseImportPage,
    SharePruefungPopover,
    DebounceChange,
    SelectKundeComponent,
    PruefpunktAddInfoComponent,
    BemerkungstextvorlagenComponent,
    AddFotoPopoverComponent,
    AddFotoPopoverComponent,
    DeleteFotoPopoverComponent,
    PopoverAddContactComponent,
    SettingTeamInvitationPage,
    VorlageneditorInspectionpointDetailsPage,
    VorlageneditorInspectionpointDetailsNewReviewPage,
    ColorPicker,
    PopoverColorChooser,
    VorlageneditorMasterdataDetailsPage,
    SettingPersonalDataPage,
    ForgotPasswordPage,
    CommentListComponent,
    AnmerkungstextvorlagenComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      mode: 'ios',
      backButtonText: 'Zurück',
      swipeBackEnabled: false,
      cancelText: 'Abbrechen'
      // locationStrategy: 'path',
      // preloadModules: true
    },
    //   {
    //   links: [
    //     { component: HomePage, name: "HomePage", segment: ""},
    //     { component: SettingPage, name: "SettingPage", segment: "settings", defaultHistory: [HomePage]},
    //     { component: PruefungPage, name: "PruefungPage", segment: "pruefung/:pruefungId", defaultHistory: [HomePage], priority: 'high'},
    //     { component: PruefungAllgemeinPage, name: "PruefungAllgemeinPage", segment: "allgemein", defaultHistory: [HomePage, PruefungPage] },
    //     { component: PruefungKundePage, name: "PruefungKundePage", segment: "kunde", defaultHistory: [HomePage]},
    //     { component: PruefungStandortPage, name: "PruefungStandortPage", segment: "standorte", defaultHistory: [HomePage]},
    //     { component: PruefungProtokollePage, name: "PruefungProtokollePage", segment: "protokolle", defaultHistory: [HomePage]},
    //     { component: PruefungProtokollePage, name: "PruefungProtokollePage", segment: "protokolle/protokollId", defaultHistory: [HomePage]},
    //   ]
    // }
    ),
    HelpModule,
    HomeModule,
    PruefungModule,
    SettingModule,
    NgPipesModule,
    HttpClientModule,
    DirectivesModule,
    AngularFilePickerModule,
    CleverreportStoreModule,

    StoreDevtoolsModule.instrument({
      maxAge: 50
    }),
    HttpModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    KontaktePage,
    KontakteKundenPage,
    KontakteDetailsPage,
    ModalNavPage,
    VorlageneditorPage,
    ExistsAuditCustomerPage,
    PopoverPage,
    ConflictManagementPage,
    ExistsAuditProtocolPage,
    SettingActiveContractorPage,
    SettingAdvancedPage,
    SettingCertificatePage,
    SettingRemarksPage,
    SettingNotesPage,
    AnmerkungstextvorlagenPage,
    LoginPage,
    RegisterPage,
    SettingDatabaseImportPage,
    SharePruefungPopover,
    SelectKundeComponent,
    PruefpunktAddInfoComponent,
    BemerkungstextvorlagenComponent,
    AddFotoPopoverComponent,
    AddFotoPopoverComponent,
    DeleteFotoPopoverComponent,
    PopoverAddContactComponent,
    SettingTeamInvitationPage,
    VorlageneditorInspectionpointDetailsPage,
    VorlageneditorInspectionpointDetailsNewReviewPage,
    ColorPicker,
    PopoverColorChooser,
    VorlageneditorMasterdataDetailsPage,
    SettingPersonalDataPage,
    ForgotPasswordPage,
    CommentListComponent,
    AnmerkungstextvorlagenComponent
  ],
  providers: [
    BackgroundMode,
    StatusBar,
    SplashScreen,
    /*{provide: ErrorHandler, useClass: IonicErrorHandler},*/
    DataProvider,
    Camera,
    ImagePicker,
    Contacts,
    LoadingServiceProvider,
    GlobalProvider,
    EmailComposer,
    File,
    DocumentViewer,
    CookieService,
    ImportProvider,
    Network,
    CalendarProvider,
    Calendar,
    InAppBrowser,
    FileTransfer,
    SQLite,
    FileOpener,
    SecureStorage,
    Device,
    LoginProvider,
    {provide: HTTP_INTERCEPTORS, useClass: CrHttpInterceptor, multi: true},
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts